<div class="background-cover"></div>
<div class="ops-subscription-message-modal">
  <div class="profile-container">
    <div class="settings-section selections">
      <label class="section-label">{{ modalTitle }}</label>

      <div class="profile-form">
        <span [innerHTML]="modalText"></span>
      </div>

      <div class="create-actions" *ngIf="!isConfirmation">
        <svg
          *ngIf="!isError"
          xmlns="http://www.w3.org/2000/svg"
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#53FBB4" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.78027 21.0828L18.1329 29.0233L31.5529 11.7275"
            fill="#53FBB4"
          />
          <path
            d="M9.78027 21.0828L18.1329 29.0233L31.5529 11.7275"
            stroke="black"
          />
        </svg>

        <svg
          *ngIf="isError"
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#FF6060" />
          <line x1="14" y1="21.5" x2="29" y2="21.5" stroke="black" />
        </svg>

        <button class="cancel-button" (click)="onClose()">
          <!-- Close -->
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L7.02457 7.11188" stroke="#747EFA" />
            <path d="M12.9582 1L6.93359 7.11188" stroke="#747EFA" />
            <path d="M12.957 13.1113L6.93246 6.99944" stroke="#747EFA" />
            <path d="M0.998866 13.1113L7.02344 6.99944" stroke="#747EFA" />
          </svg>
        </button>
      </div>

      <div class="login-form" *ngIf="isConfirmation">
        <button (click)="onConfirm()" type="button" class="login-btn">
          {{ 'OPS_SUBSCRIPTION_MESSAGE_MODAL.CONFIRM' | translate }}
        </button>

        <button (click)="onClose()" type="button" class="close-btn">
          {{ 'OPS_SUBSCRIPTION_MESSAGE_MODAL.CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
